import React, { useContext, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { ThemeContext } from "../../../context/ThemeContext";
import "./Refund.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Refund = () => {
  const { darkMode } = useContext(ThemeContext);
  const [scrolled, setScrolled] = React.useState(false);
  const [activeSection, setActiveSection] = React.useState("refund");

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 800,
      once: false,
      mirror: true,
    });

    const handleScroll = () => {
      if (window.scrollY > 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Smooth scroll function
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const targetSection = document.getElementById(targetId);
    if (targetSection) {
      const offsetTop =
        targetSection.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={`refund-container ${darkMode ? "dark-mode" : ""}`}>
      <Navbar
        scrolled={scrolled}
        activeSection={activeSection}
        handleNavClick={handleNavClick}
      />

      <div className="refund-content" id="refund">
        <div className="container py-5 mt-5">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="refund-header">
                <h1 data-aos="fade-up" className="refund-title">
                  Refund Policy
                </h1>
                <p
                  data-aos="fade-up"
                  data-aos-delay="100"
                  className="refund-subtitle"
                >
                  Last updated: {new Date().toLocaleDateString()}
                </p>
              </div>

              <div
                className="refund-section"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <h2>1. Overview</h2>
                <p>
                  We strive to provide a reliable and valuable service through
                  NUMRA. If you are not satisfied with your subscription, please
                  review the policy below.
                </p>
              </div>

              <div
                className="refund-section"
                data-aos="fade-up"
                data-aos-delay="250"
              >
                <h2>2. Billing and Refund Handling</h2>
                <p>
                  All payments, billing, and refunds are processed by our
                  Merchant of Record, Paddle.com. Refund requests may be subject
                  to Paddle's Refund Policy.
                </p>
              </div>

              <div
                className="refund-section"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <h2>3. Refund Eligibility</h2>
                <p>You may be eligible for a refund if:</p>
                <ul>
                  <li>
                    You cancel within 7 days of your first subscription payment
                    (money-back guarantee)
                  </li>
                  <li>
                    You encounter critical, unresolved service issues for more
                    than 14 consecutive days
                  </li>
                </ul>
              </div>

              <div
                className="refund-section"
                data-aos="fade-up"
                data-aos-delay="350"
              >
                <h2>4. Non-Refundable Situations</h2>
                <p>Refunds are not granted for:</p>
                <ul>
                  <li>Partial use of the subscription</li>
                  <li>User misconfiguration or misuse</li>
                  <li>Downtime caused by third-party service issues</li>
                </ul>
              </div>

              <div
                className="refund-section"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <h2>5. Requesting a Refund</h2>
                <p>
                  To request a refund, contact us at{" "}
                  <a href="mailto:support@numra.com">support@numra.com</a> or
                  use the Paddle support link provided in your email receipt.
                  Refunds will typically be processed within 7–10 business days.
                </p>
              </div>

              <div
                className="refund-section"
                data-aos="fade-up"
                data-aos-delay="450"
              >
                <h2>6. Subscription Cancellation</h2>
                <p>
                  You can cancel your subscription at any time. Service will
                  remain active until the end of your billing period, after
                  which no further charges will occur.
                </p>
              </div>

              <div
                className="refund-contact"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <h2>Contact Us</h2>
                <p>
                  If you have any questions about our Refund Policy, please
                  contact us at{" "}
                  <a href="mailto:support@numra.com">support@numra.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Refund;
